import React, { FC } from 'react';

import { RadioSelectOption } from '../../../../../../components/inputs/RadioSelectScrollable';
import BasicButton from 'components/buttons/basicButton';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';

import DatasetColumnSelect from './DatasetColumnSelect';

interface DatasetConfigurationalFooterProps {
    isEditable: boolean;
    rowCount: number;
    showRowCount: boolean;
    actionButtonText: string;
    handleClose: () => void;
    handleChange: () => void;
    isActionDisabled?: boolean;
    showColumnSelect?: boolean;
    selectedFieldId?: string;
    setSelectedFieldId?: (id: string) => void;
    columnOptions: RadioSelectOption[];
}

const DatasetConfigurationalFooter: FC<DatasetConfigurationalFooterProps> = ({
    isEditable,
    rowCount,
    showRowCount,
    actionButtonText,
    handleClose,
    handleChange,
    isActionDisabled = false,
    showColumnSelect,
    selectedFieldId,
    setSelectedFieldId,
    columnOptions,
}) => {
    return (
        <Footer>
            {showColumnSelect && (
                <DatasetColumnSelect
                    columnOptions={columnOptions}
                    selectedColumn={selectedFieldId}
                    onApply={(val: string) => {
                        setSelectedFieldId?.(val);
                    }}
                />
            )}
            <div>
                {showRowCount && (
                    <RowCount>Filtered row count: {rowCount}</RowCount>
                )}
            </div>
            <ActionContainer>
                <StyledButton
                    isPrimary={false}
                    name="Cancel"
                    action={handleClose}
                    type="button"
                />
                <StyledButton
                    name={actionButtonText}
                    disabled={!isEditable || isActionDisabled}
                    action={handleChange}
                />
            </ActionContainer>
        </Footer>
    );
};

export default DatasetConfigurationalFooter;

const Footer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: aampeTheme.spacing4(8),
});

const ActionContainer = styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: aampeTheme.spacing4(2),
});

const RowCount = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
});

const StyledButton = styled(BasicButton)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    borderRadius: aampeTheme.borderRadius.medium,
    fontWeight: aampeTheme.weights.medium,
});
